module.exports = require('./lib/ReactS3');


// WEBPACK FOOTER //
// ./src/react-s3/index.js